import { createContext, useState, useEffect, useContext} from "react";
import { RouteProps } from "react-router-dom";
import { GoogleAuthProvider, onAuthStateChanged, signInWithPopup, signOut } from "firebase/auth";
import { auth } from "../db";



export const AuthContext = createContext<any>({})

export const useAuth = () => useContext(AuthContext)

export default function AuthContextProvider({children}:RouteProps) {

    const [user,setUser] = useState<any>(null)
    const [loading,setLoading] = useState(true)

    useEffect(() => {
        const logout = onAuthStateChanged(auth, (user) => {
            if(user?.uid === 'dssM81oX8EO2T8B79701ZPE17qu1'){

                setUser({
                    id:user.uid,
                    name:user.displayName
                })
            }else {
                setUser(null)
            }
            setLoading(false)
        })

        return () => logout()
    },[])

    const login = async () => {
        const provider = new GoogleAuthProvider()
        return signInWithPopup(auth,provider)
    }
    const logout = async () => {
        setUser(null)
        await signOut(auth)
    }

    return(
        <AuthContext.Provider value={{ user ,login, logout}}>
            {loading ? null : children}
        </AuthContext.Provider>
    )

}